import { useState } from 'react';

export const useSessionCodeLanguage = (
  defaultLanguages: string[] = [],
): [string[], (value: string) => void, (values: string[]) => void] => {
  const [languages, setLanguages] = useState<string[]>(
    Object.values(defaultLanguages.map(item => item.toLocaleLowerCase())),
  );

  const handleChangeLanguage = (value: string) => {
    setLanguages(currentLanguages => {
      // Set will only add unique values to the array
      const temp = [
        ...new Set([value.toLocaleLowerCase(), ...currentLanguages]),
      ];

      return temp;
    });
  };

  const handleChangeFromArray = (values: string[]) => {
    setLanguages(currentLanguages => {
      const temp = [
        ...new Set([
          ...values.map(item => item.toLocaleLowerCase()),
          ...currentLanguages,
        ]),
      ];

      return temp;
    });
  };

  return [languages, handleChangeLanguage, handleChangeFromArray];
};
